<template>
  <span v-if="this.isToday || this.isYesterday">{{formatDate}}</span>
  <time v-else>{{formatDate}}</time>
</template>

<script lang="ts">
import Vue from "vue";
import DatetimeHelper from "../helpers/datetimeHelper";
import {DatetimeMode} from "~/models/datetimeMode";
import moment from 'moment-timezone';
export default Vue.extend({
  props: {
    created_at: {
      type: String
    },
    timezone: {
      type: String,
      required: false,
      default: "EST"
    }
  },
  mixins: [],
  data: function() {
    return {};
  },
  computed: {
    formatTime() {
      return moment(this.created_at)
        .tz(this.timezone)
        .format("h:mm A")
    },
    localText() {
      return DatetimeHelper.toZonedTimeString(this.created_at, {timezone: this.timezone});
    },
    formatDate(): string {
      if (this.isToday){
        return `${this.formatTime} today`
      } else if(this.isYesterday)
      {
        return `${this.formatTime} yesterday`
      } else{
        return moment(this.created_at)
          .tz(this.timezone)
          .format("h:mm A on MMM Do, YYYY");
      }
    },
    isToday(){
      let date = DatetimeHelper.parseDate(this.created_at, this.timezone, 'MMMM D, YYYY')
      const today = new Date()
      return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear()
    },
    isYesterday(){
      let date = DatetimeHelper.parseDate(this.created_at, this.timezone, 'MMMM D, YYYY')
      const today = new Date()
      return date.getDate() === today.getDate() -1  && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear()
    }
  }
});
</script>